import React, { createContext, useContext } from "react";

// ============== Bulk Select Context (admin only) ==============
export const BulkSelectContext = createContext(null);
export const useBulkSelect = () => useContext(BulkSelectContext);

export function BulkCheckbox({ id, className = "" }) {
  const ctx = useBulkSelect();
  if (!ctx || !ctx.bulkMode || !id) return null;
  const checked = ctx.selected.has(id);
  return (
    <label
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center justify-center bg-white border-2 border-red-400 rounded p-0.5 shadow-md cursor-pointer hover:border-red-600 hover:bg-red-50 ${className}`}
      data-testid={`bulk-check-${id}`}
      title="Selectează pentru ștergere"
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => { e.stopPropagation(); ctx.toggle(id); }}
        className="w-4 h-4 accent-red-600 cursor-pointer"
        aria-label="Selectează produs"
      />
    </label>
  );
}

export function BulkHeaderCheck({ items }) {
  const ctx = useBulkSelect();
  if (!ctx || !ctx.bulkMode) return null;
  const allIds = (items || []).map((i) => i.id).filter(Boolean);
  const allSelected = allIds.length > 0 && allIds.every((id) => ctx.selected.has(id));
  return (
    <input
      type="checkbox"
      checked={allSelected}
      onChange={() => {
        allIds.forEach((id) => {
          if (allSelected && ctx.selected.has(id)) ctx.toggle(id);
          else if (!allSelected && !ctx.selected.has(id)) ctx.toggle(id);
        });
      }}
      className="w-4 h-4 accent-red-600 cursor-pointer"
      title={allSelected ? "Deselectează tot" : "Selectează tot"}
      data-testid="bulk-header-check"
    />
  );
}
